import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from 'antd';

type Props = {
  title?: string;
  subTitle?: string;
  continueLink?: string;
  continueText?: string;
};

const Working = ({
  title = 'Working...',
  subTitle = 'Please wait while we process your request.',
  continueLink,
  continueText = 'Continue',
}: Props) => {
  return (
    <Result
      icon={
        <Spin indicator={<LoadingOutlined style={{ fontSize: 72 }} spin />} />
      }
      title={title}
      subTitle={subTitle}
      extra={
        continueLink ? (
          <Link to={continueLink}>
            <Button type="primary">{continueText}</Button>
          </Link>
        ) : undefined
      }
    />
  );
};

export default Working;
